<!-- Directory + Feedback card (ported from account-v1 guestCard.html) -->
<!-- Directory card -->
<div class="ft-panel ft-person-panel"
     (click)="select(guest)"
     *ngIf="type === 'directory'">
    <div class="ft-personid">
        <ft-guest-photo [src]="guest.profileImageUrl"
                        [silhouetteClass]="guest.silhouetteClass" />
        <div class="ft-person-name">{{guest | fullName}}</div>
        <div class="ft-person-social-count"
             *ngIf="guest.networkSize > 0">
            <div class="ft-count">{{guest.networkSize | number}}</div>
        </div>
    </div>

    <div class="ft-person-activity">
        <div class="ft-activity-row" *ngIf="guest.pmsNumber || guest.crsNumber">
            <div class="ft-label">
                Reservation
            </div>
            <div class="ft-detail">
                {{guest.pmsNumber || guest.crsNumber}}
            </div>
        </div>

        <div class="ft-activity-row" *ngIf="guest.epochCheckInDate != guest.epochCheckOutDate">
            <div class="ft-label">
                Stay Dates
            </div>
            <div class="ft-detail" [ngClass]="{'ft-stay-canceled': guest.isCanceled}">
                {{guest.epochCheckInDate | dateFormat: 'MMM D'}} - {{guest.epochCheckOutDate | dateFormat: 'MMM D, YYYY'}}
                <span *ngIf="guest.isCanceled" class="ft-stay-canceled-label">Canceled</span>
            </div>
        </div>

        <div class="ft-activity-row" *ngIf="guest.epochCreateDate">
            <div class="ft-label">
                Discovered
            </div>
            <div class="ft-detail">
                <span *ngIf="guest.promoterLogID == 1">{{'flipto.account.BookedStay' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 2">{{'flipto.account.FollowupClick' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 3">{{'flipto.account.PoststayClick' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 5">{{'flipto.account.FollowupBatchFile' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 6">{{'flipto.account.ReviewBatchFile' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 7">{{'flipto.account.PrearrivalEmailView' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 8">{{'flipto.account.ConfirmationEmailView' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 9">{{'flipto.account.PoststayEmailView' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 10">{{'flipto.account.BookedStay' | translate}} </span>
                <span *ngIf="guest.promoterLogID == 11">{{'flipto.account.Invitee' | translate}} </span>
                {{guest.epochCreateDate | dateFormat: 'MMM D, YYYY'}}
            </div>
        </div>

        <div class="ft-activity-row"
             *ngIf="guest.epochLastActivityDate">
            <div class="ft-label">
                Last Activity
            </div>
            <div class="ft-detail">
                <span>{{guest.lastActivityType | activityType}} </span><span>{{guest.epochLastActivityDate | dateFormat: 'MMM D, YYYY'}}</span>
            </div>
        </div>
    </div>
</div>

<!-- Feedback -->
<div class="ft-panel ft-story-panel"
     (click)="select(guest)"
     *ngIf="type === 'feedback'">
    <div [class]="'ft-content feedback ft-rating-' + guest.quote.rating">
        <div class="ft-feedback"
             *ngIf="guest.quote.notesNegative"
             [innerHTML]="guest.quote.notesNegative | truncate:200:true | quot">
        </div>
        <div class="ft-feedback-rating">
            <div [class]="'ft-rating-' + guest.quote.rating"
                 *ngIf="guest.quote.rating >= 0">{{guest.quote.rating}}&nbsp;out of 5</div>
        </div>
    </div>

    <div class="ft-personid">
        <ft-guest-photo [src]="guest.promoter.profileImageUrl"
                        [silhouetteClass]="guest.promoter.silhouetteClass" />
        <div class="ft-person-name">{{guest.promoter | fullName}}</div>
        <div class="ft-person-social-count"
             *ngIf="guest.promoter.networkSize > 0">
            <div class="ft-count">{{guest.promoter.networkSize | number}}</div>
        </div>
    </div>
</div>
